import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {JwtHelperService} from '@auth0/angular-jwt';
import { HttpClient } from '@angular/common/http';
import {AuthenticationService} from '../services/authentication.service';

@Injectable( { providedIn: 'root' } )
export class AuthorizationCheck implements CanActivate {

  constructor(private jwtHelper: JwtHelperService, private router: Router,
              private http: HttpClient, private authenticationService: AuthenticationService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const token = localStorage.getItem('TokenInfo');

    // If token data exist, user may login to application
    if (token && !this.jwtHelper.isTokenExpired(token)) {
      //console.log(this.jwtHelper.decodeToken(token));
      return true;
    }

    const isRefreshSuccess = await this.authenticationService.tryRefreshingTokens(token);
    if (!isRefreshSuccess) {
      setTimeout(() => {
        this.authenticationService.forceCloseModal();
        this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
      }, 800);
    }
    return isRefreshSuccess;
  }
}
